<template>
  <div class="info">
    <div class="content">
      <router-link class="cross" :to="{ path: '/' }">
        &times;
      </router-link>
      <h1>#CreativityIsNotCancelled</h1>
      <p>Creativity is NOT cancelled. While borders are being closed and social distancing impacts many communities across the globe, it feels more important than ever to find ways to stick together. From Shanghai, to Rome and London.</p><p>Join our live digital artboard and help design the letters!  We invite you to take a little time out to experiment and play. The designs will all be recorded in real-time and revealed at the end of the week via instagram!</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Info'
}
</script>

<style lang="scss" scoped>
.info {
  // background: rgba(255,255,255,0.5);
  // background: rgba(0,0,0,0.9);
  position: absolute;
  @media screen and (max-width: 640px) {
    overflow: auto;
    scroll-behavior: smooth;
    z-index: 99999;
    padding: 1rem;
  }
}
.cross {
  position: absolute;
  right: 0rem;
  top: .5rem;
  font-size: 3rem;
  height: 1em;
  width: 1em;
  line-height: 1;
  color: inherit;
  font-weight: 200;
  /* color: white; */
  cursor: pointer;
}
.content {
  margin: auto;
  width: 95%;
  max-width: 30rem;
  // position: absolute;
  // transform: translate3d(-50%, -50%, 0);
  // top: 50%;
  // left: 50%;
  position: relative;
  padding: 4rem 1.5rem 2rem;
  background: white;
  color: #000;
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(255, 117, 28, 1);
  // overflow: auto;
  // scroll-behavior: smooth;
  // height: 100%;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
  overflow: hidden;
  padding: 1rem 2rem;

  // box-shadow: 0px 0px 100px 0px rgba(255, 117, 28, 1);

  @media screen and (min-width: 640px) {
    position: absolute;
    transform: translate3d(-50%, -50%, 0);
    top: 50%;
    left: 50%;
    overflow: hidden;
    padding: 1rem 2rem;
    box-shadow: 0px 0px 100px 0px rgba(255, 117, 28, 1);
  }
}
h1 {
  font-size: 1rem;
  text-align: center;
  margin-bottom: 2em;
  font-weight: 400;
}
p {
  line-height: 1.5;
  font-weight: 400;
}
</style>
